export default "__VITE_ASSET__DXfVxVEO__"